import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeatureFlagService } from '@core/feature-flag/feature-flag.service';
import { Feature } from '@core/feature-flag/feature.enum';

export const maintenanceGuard: CanActivateFn = (_, state) => {
  const router = inject(Router);
  const featureFlagService = inject(FeatureFlagService);
  const targetUrl = state.url;

  const isMaintenance = featureFlagService.isFeatureEnabled(Feature.MaintenanceMode);
  const isOnMaintenancePage = targetUrl.startsWith('/maintenance');

  if (isMaintenance && !isOnMaintenancePage) {
    return router.createUrlTree(['/maintenance']);
  }

  if (!isMaintenance && isOnMaintenancePage) {
    return router.createUrlTree(['/login']);
  }

  return true;
};
